// extracted by mini-css-extract-plugin
module.exports = {"curatorsListWrapper":"_3hR0D","curatorsListTitle":"d2Z1k","curatorsList":"o7fm2","curatorsItem":"_31QRE"};